import { Globe } from "lucide-react";

export default function LanguageSwitcher({ compact = false }) {
  return (
    <div
      data-testid="language-switcher"
      className={`flex items-center gap-2 ${compact ? "" : "px-3 py-1 border border-brand-gold/30 hover:border-brand-gold transition-colors"}`}
    >
      <Globe size={14} className="text-brand-gold flex-shrink-0" />
      <div id="google_translate_element" />
    </div>
  );
}
